import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { eventActions } from '../../../../../../store/modules/event';
import { asyncSimpleModal, getKeyByValue, setMultipartForm } from '../../../../../../lib/common';
import toastMsg from '../../../../../../lib/toastMsg';
import EventApi from '../../../../../../lib/api/event/EventApi';
import { TagItem } from '../../../types';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../../constants/service/common/utilConstants';
import eventToastMsg from '../../../../../../constants/service/toastMsg/eventToastMsg';
import { TAG_STATUS } from '../../../../../../constants/service/app/tagConstants';

interface UseExcelProps {
  value: TagItem[];
  onChange?: (value: TagItem[]) => void;
}
const useExcel = (props: UseExcelProps) => {
  const { value, onChange } = props;
  const [isExcelUploadSuccess, setIsExcelUploadSuccess] = useState(false);
  const dispatch = useDispatch();
  const excelUpload = useMutation({
    mutationFn: (data: { attachment: File[] }) => EventApi.setEventTagExcelUpload(setMultipartForm(data, true)),
    onSuccess: async (result: any) => {
      if (result.msg) throw new Error(result.msg);
      if (!onChange) return;
      toastMsg.success(eventToastMsg.SET_EVENT_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS);
      setIsExcelUploadSuccess(true);

      const { itemList } = result.data;
      onChange(
        itemList.map((item: any) => ({
          id: item.id,
          name: item.name,
          status: getKeyByValue(TAG_STATUS, item.status),
          tagGroupList: Array.isArray(item.tagGroupList) ? item.tagGroupList.map((item: string) => item) : [],
          imageUrl: typeof item.url === 'string' ? item.url : '',
        })),
      );

      await asyncSimpleModal({
        type: 'info',
        title: '태그 업로드',
        message: `${itemList.length}개의 태그 아이템이 성공적으로 등록되었습니다.`,
      });
    },
    onError: (error: Error) => {
      toastMsg.error(error.message || eventToastMsg.SET_EVENT_TAG_EXCEL_UPLOAD_REQUEST_ERROR, error);
    },
  });

  /**
   * 선택된 상품 엑셀 다운로드
   */
  const downloadSelectedExcel = () => {
    if (!value.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    dispatch(
      eventActions.getEventTagSelectedListExcelDownload({
        tagIdList: value.map((item) => item.id),
      }),
    );
  };

  /**
   * 태그 업로드
   */
  const uploadExcel = (file: File) => {
    excelUpload.mutate({ attachment: [file] });
    setIsExcelUploadSuccess(false);
  };

  return {
    isExcelUploadSuccess,
    downloadSelectedExcel,
    uploadExcel,
  };
};

export default useExcel;
